"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));

var _default = function _default(_ref) {
  var inputRef = _ref.inputRef,
      onChange = _ref.onChange,
      other = (0, _objectWithoutProperties2["default"])(_ref, ["inputRef", "onChange"]);
  return /*#__PURE__*/_react["default"].createElement(_reactNumberFormat["default"], (0, _extends2["default"])({}, other, {
    getInputRef: inputRef,
    onValueChange: function onValueChange(values) {
      onChange({
        target: {
          value: values.value ? parseInt(values.value, 10) : values.value
        }
      });
    },
    thousandSeparator: true,
    isNumericString: true
  }));
};

exports["default"] = _default;